module.exports = __webpack_public_path__ + "img/18.6f227c94.svg";